import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getConfirmationDialog } from '../../Selectors'
import ConfirmModal from '../../../components/ConfirmModalV2'
import useSpinner from '../../../context/hooks/useSpinner'
import callable from '../../../utils/callable'
import { setConfirmationDialog } from '../../ActionCreators'

/**
 * General confirmation dialog with customizable title, message, and confirm action
 *
 * @returns {React.Element}
 */
export const VNConfirmationDialog = () => {
  const dispatch = useDispatch()
  const { open, title, message, confirmText, onConfirm } = useSelector(getConfirmationDialog)
  const { showSpinner, stopSpinner } = useSpinner()

  useEffect(() => {
    if (!message) return
    if (!showSpinner) return

    stopSpinner()
  }, [message, showSpinner, stopSpinner])

  const handleClose = () => {
    dispatch(setConfirmationDialog(null))
  }

  const handleConfirm = () => {
    callable(onConfirm)
    handleClose()
  }

  if (!open) {
    return null
  }

  return (
    <ConfirmModal
      headerText={title}
      subtext={message}
      onButtonOneClick={handleClose}
      singleButtonOnly={!onConfirm}
      buttonTwoText={confirmText}
      onButtonTwoClick={handleConfirm}
    />
  )
}
